import React from "react";
import ReactDOM from "react-dom/client";
import { Collection } from "@app/components/pageCollection/Collection";

class CollectionPage extends HTMLElement {
  collectionHandle: string;

  constructor() {
    super();
    this.collectionHandle = this.getAttribute("data-collection-handle") || "";
  }

  connectedCallback() {
    this.initReactify();
  }

  initReactify() {
    const root = ReactDOM.createRoot(this);
    root.render(<Collection handle={this.collectionHandle} />);
  }
}

customElements.define("collection-page", CollectionPage);
